export const FORNECEDOR_SIM = 1;

export const FORNECEDOR_SIM_TOOLTIP =
  'Cadastro exclusivo via Plataforma Logística';

export const FORNECEDOR_SIM_SUBMIT_ERROR =
  'Não é permitido cadastrar ou alterar fornecedor neste sistema. Utilize a Plataforma Logística.';
